import React from 'react';

import { useIntl } from 'react-intl';

import { NavEmptyState } from '@atlassian/navigation-common/ui/nav-empty-state';

import { messages } from '../../messages';

export const NoResultsState = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<NavEmptyState
			header={formatMessage(messages.noResultsTitle)}
			description={formatMessage(messages.noResultsMessage)}
			renderImage={() => <></>}
		/>
	);
};
